import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'app/shared/material/material.module';
import { PipesModule } from 'app/shared/pipes/pipes.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AppRoutingModule } from 'app/app-routing.module';

@NgModule({
  declarations: [
    // AdminComponent,
    // AdminBookingClubComponent,
    // AdminClubDetailsComponent,
    // TableOfferClosedComponent,
    // TableOffersBookedClubComponent,
    // TableOffersClubComponent,
    // AdminClubsComponent,
    // AdminFilterTableComponent,
    // AdminHomeComponent,
    // AdminMyClubComponent,
    // AdminOfferComponent,
    // AdminOfferAddComponent,
    // AdminOfferTableComponent,
    // AdminOfferPriorityComponent,
    // AdminPracticePlaceComponent,
    // TablePracticeClubSoloComponent,
    // TablePracticePlaceByClubComponent,
    // AdminPreviewOfferComponent,
    // AdminStructureComponent,
    // AdminStructureAddComponent,
    // AdminStructureDetailsComponent,
    // AdminStructureDetailsUpdateComponent,
    // PopUpFilterComponent,
    // MatAccordionTreeComponent,
    // InfosBookingComponent,
    // UpdateBookingFormComponent,
    // ValidationAnimationComponent
    // AdminParametersComponent,
    // AdminParametersTableComponent
    // AdminSessionsComponent
    // AdminOffersTableComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    PipesModule,
    FontAwesomeModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule
  ],
  exports: [
    // AdminComponent,
    // AdminBookingClubComponent,
    // AdminClubDetailsComponent,
    // TableOfferClosedComponent,
    // TableOffersBookedClubComponent,
    // TableOffersClubComponent,
    // AdminClubsComponent,
    // AdminFilterTableComponent,
    // AdminHomeComponent,
    // AdminMyClubComponent,
    // AdminOfferComponent,
    // AdminOfferAddComponent,
    // AdminOfferTableComponent,
    // AdminOfferPriorityComponent,
    // AdminPracticePlaceComponent,
    // TablePracticeClubSoloComponent,
    // TablePracticePlaceByClubComponent,
    // AdminPreviewOfferComponent,
    // AdminStructureComponent,
    // AdminStructureAddComponent,
    // AdminStructureDetailsComponent,
    // AdminStructureDetailsUpdateComponent,
    // PopUpFilterComponent,
    // MatAccordionTreeComponent,
    // InfosBookingComponent,
    // UpdateBookingFormComponent,
    // ValidationAnimationComponent

  ]
})
export class AdminModule { }
